export default {
  today: 'Today',
  tomorrow: 'Tomorrow',
};
